function agreeWithTermsModal() {
  var current_location_arr = ['/register_partner','/register'];
  if($("#terms_and_conditions").length > 0 && $.inArray(window.location.pathname,current_location_arr) == -1) {
    $("#terms_and_conditions").modal('show');
  }
}

// main function validation 
function validateElement($input) {
  var value = $($input).val();
  var fieldType = $($input).attr("type") != undefined ? $($input).attr("type") : $($input).prop("tagName");
  var isValid = true;
  
  switch (fieldType.toLowerCase()) {
    case "text":
      isValid = validateText($($input));
    break;
    case "textarea":
      isValid = validateTextArea($($input));
    break;
    case "number":
      isValid = validateNumber($($input));
    break;
    default:
      isValid = validateText($($input));
    break;
  };

  return isValid;
}

function validateText($input){
  var valid = true;
  if($input.val() == ''){
    valid = false;
    $input.removeClass('is-valid');
    $input.addClass('is-invalid');
    if(!$input.next(".invalid-feedback").length){
      $input.after('<div class="invalid-feedback">This field is required.</div>');
    }
  }else{
    $input.removeClass('is-invalid');
    $input.addClass('is-valid');
    $input.next(".invalid-feedback").remove();
  }
  return valid;
}

function validateTextArea($input){
  var valid = true;
  if($input.val() == ''){
    valid = false;
    $input.removeClass('is-valid');
    $input.addClass('is-invalid');
    if(!$input.next(".invalid-feedback").length){
      $input.after('<div class="invalid-feedback">This field is required.</div>');
    }
  }else{
    $input.removeClass('is-invalid');
    $input.addClass('is-valid');
    $input.next(".invalid-feedback").remove();
  }
  return valid;
}

function validateNumber($input){
  var valid = true;
  if($input.val() > 0 && $input.val() != undefined && $input.val() != ""){
    $input.removeClass('is-invalid');
    $input.addClass('is-valid');
    if($input.next("a").length){
      $input.next("a").next(".invalid-feedback").remove();
    }else{
      $input.next(".invalid-feedback").remove();
    }
  }else{
    valid = false;
    $input.removeClass('is-valid');
    $input.addClass('is-invalid');
    
    if(!$input.next(".invalid-feedback").length){
      $input.after('<div class="invalid-feedback">This field is required.</div>');
    }
  }
  return valid;
}

$(document).ready(function()
{
    agreeWithTermsModal();

	  // CHANGE LANGUAGE
    $(document).on("click", ".change_language", function(e) {
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var language_id = $(this).data('language_id');
      var language_name = $(this).data('language_name');
      $.ajax({
          type: "POST",
          url: '/update_language',
          dataType: "JSON",
          data: {'language_id': language_id, 'language_name': language_name},
          success: function(data) {
            location.reload();
          }
      }); 
    });

    // DELETE/ACTIVATE USER ACCOUNT
    $(document).on("click", ".account_status", function(e) {
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var user_id = $(this).data('user_id');
      var url = $(this).data('url');
      $(this).attr("disabled","true");

      $.ajax({
          type: "POST",
          url: '/' + url,
          dataType: "JSON",
          data: {'user_id': user_id},
          success: function(data) {
            location.reload();
          }
      }); 
    });

    // SHOW REGISTER LEGAL PERSON
    $(document).on("click", "#legal_person", function() {
      $('.hide_legal_form').removeClass('d-none');
      $('.register-footer').addClass('mt-5');
      $('.block-center').removeClass('ninety-vh');
      $('.logo').addClass('mt-5');
    });

    // SHOW REGISTER INDIVIDUAL PERSON WHEN ERRORS OCCURS
    if($('#individual_person').is(":checked")){
      $('.hide_legal_form').addClass('d-none');
      $('.hide_legal_form input').val('');
    }else if($('#legal_person').is(":checked")){
      $('.hide_legal_form').removeClass('d-none');
    }

    // SHOW REGISTER INDIVIDUAL PERSON
    $(document).on("click", "#individual_person", function() {
      $('.hide_legal_form').addClass('d-none');
      $('.register-footer').removeClass('mt-5');
      $('.block-center').addClass('ninety-vh');
      $('.logo').removeClass('mt-5');
      $('.hide_legal_form input').val('');
    });

    // TRIGGER PARTNER REGISTRATION
    $(document).on("click", ".next_step_partner_registration,.finish_partner_registration", function(e) {
      e.preventDefault();
      var next_step = $(this).find('.btn_value').val();
      $('#partner_registration_step').val(next_step);
      $('#register_partner').submit();
    });

    // SHOW ADDITIONAL PARTNER FIELDS
    $(document).on("change", "#user_type", function() {
      var user_type = $(this).val();
      if(user_type == 'partner'){
        $('.partner_additional_fields').removeClass('d-none');
      }else{
        $('.partner_additional_fields').addClass('d-none');
      }
    });

    // SHOW DROPDOWN INPUT ON CATEGORY FIELD TRANSLATIONS
    $(document).on("change", "#type", function() {
      var type = $(this).val();
      if(type == 'dropdown'){
        $('.dropdown_options').removeClass('d-none');
      }else{
        $('.dropdown_options').addClass('d-none');
        $('.dropdown_options input').val('');
      }
    });

    // SHOW ADDITIONAL PARTNER FIELDS WHEN ERRORS OCCURS
    if($('#user_type').val() == 'partner'){
      $('.partner_additional_fields').removeClass('d-none');
    }

    // PREVIOUS STEP PARTNER REGISTRATION
    $(document).on("click", ".previous_step_partner_registration", function(e) {
      e.preventDefault();
      var current_step = $('#partner_registration_step').val();
      $('#register_partner' + ' .mesage_form_package').remove();
      switch (current_step) {
        case 'partner_registration_step_0':
            $('.partner_registration_step_0').removeClass('d-none');
            $('.partner_registration_step_1').addClass('d-none');
            $('.previous_step_partner_registration').addClass('d-none');
            $('.next_step_partner_registration').find('.btn_value').val(current_step);
            // We came back to step #1, there should be no circles highlighted.
            $('.steps-container .number').removeClass('done');
          break;
        case 'partner_registration_step_1':
            $('.partner_registration_step_1').removeClass('d-none');
            $('.partner_registration_step_2').addClass('d-none');
            $('.next_step_partner_registration').find('.btn_value').val(current_step);
            $('#partner_registration_step').val('partner_registration_step_0');
            // We came back to step #2, there should be no circles highlighted.
            $('.steps-container .number').removeClass('done');
          break;
        case 'partner_registration_step_2':
            console.log('step 2');
            $('.partner_registration_step_2').removeClass('d-none');
            $('.partner_registration_step_3').addClass('d-none');
            $('.next_step_partner_registration').find('.btn_value').val(current_step);
            $('#partner_registration_step').val('partner_registration_step_1');
            // We came back to step #3, only the 'Legal' circle should be highlighted.
            if ( $('.steps-container .number.two').hasClass('done') ) {
              $('.steps-container .number.two').removeClass('done');
            }
            $('.steps-container .number.one').addClass('done');
          break;
        case 'partner_registration_step_3':
            console.log('step 3');
            $('.partner_registration_step_2').removeClass('d-none');
            $('.partner_registration_step_3').addClass('d-none');
            $('.next_step_partner_registration').removeClass('d-none');
            $('.finish_partner_registration').addClass('d-none');
            $('#partner_registration_step').val('partner_registration_step_2');
            $('.steps-container .number.two').addClass('done');
          break;
      }
    });

    // PARTNER REGISTRATION
    $(document).on('submit', '#register_partner', function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      $.ajax({
          type: "POST",
          url: '/create_partner',
          dataType: "JSON",
          data: $(this).serialize(),
          success: function(data) {
            $('#register_partner' + ' .mesage_form_package').remove();
            switch (data.responseText) {
              case 'partner_registration_step_1':
                  $('.partner_registration_step_0').addClass('d-none');
                  $('.partner_registration_step_1').removeClass('d-none');
                  $('.previous_step_partner_registration').removeClass('d-none');
                  $('.next_step_partner_registration').find('.btn_value').val(data.responseText);
                break;
              case 'partner_registration_step_2':
                  $('.partner_registration_step_1').addClass('d-none');
                  $('.partner_registration_step_2').removeClass('d-none');
                  $('.next_step_partner_registration').find('.btn_value').val(data.responseText);
                  $('.steps-container .number.one').addClass('done');
                break;
              case 'partner_registration_step_3':
                  $('.partner_registration_step_2').addClass('d-none');
                  $('.partner_registration_step_3').removeClass('d-none');
                  $('.finish_partner_registration').removeClass('d-none');
                  $('.next_step_partner_registration').addClass('d-none');
                  $('#partner_registration_step').val(data.responseText);
                  $('.steps-container .number.two').addClass('done');
                break;
              case 'finish_partner_registration':
                  $('.finish_registration_header').addClass('d-none');
                  $('.finish_registration_body').addClass('d-none');
                  $('.congratulations_step').removeClass('d-none');
                  $('.steps-container .number.three').addClass('done');
                  setTimeout(function(){
                    location.href = '/login';
                  }, 3000);
                break;
            }
          },
          error: function(data){
            var returnedData = JSON.parse(data.responseText);
            $('#partner_registration_step').val(returnedData.current_step);
            
            $('#register_partner' + ' .mesage_form_package').remove();
            $('#register_partner').prepend("<div class='alert alert-danger mesage_form_package'></div>");

            $.each(returnedData.messages, function( index, value ) {
              $('#register_partner' + " .mesage_form_package").append(value + "<br>");
            });         
          }
      }); 
    });

    // DISABLE SUBMIT BUTTON AFTER FORM SUBMIT
    $(document).on("click", ".create_user", function(e) {
      e.preventDefault();
      $(this).attr("disabled","true");
      $(this).closest('form').submit();
    });

    // CHECK ALL OPTIONS THAT BELONGS TO AN OPTION LIST
    $(document).on("click", ".check_all_options", function() {
      var option_list_id = $(this).val();
      if($(this).is(":checked")){
        $('.checkbox_options_' + option_list_id).prop('checked', true);
      }else{
        $('.checkbox_options_' + option_list_id).prop('checked', false);
      }
    });

    // UNCHECK CHECKBOX FROM OPTION LIST
    $(document).on("click", ".checkbox_individual_option", function() {
      var option_list_id = $(this).data('option_list_id');
      if($('.checkbox_options_' + option_list_id + ':checked').length == $('.checkbox_options_' + option_list_id).length){
        $('#checkbox_option_list_' + option_list_id).prop('checked', true);
      }else{
        $('#checkbox_option_list_' + option_list_id).prop('checked', false);
      }
    });

    // SUBMIT ADD OPTION FORM
    $(document).on("click", ".create_option", function(e) {
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      e.preventDefault();
      var holder = '#add_option_form';
      
      var formdata = new FormData(); 
      if($('#option_image_upload')[0].files[0]){
        formdata.append('display_image',$('#option_image_upload')[0].files[0]);
      }
      formdata.append('form_value',$(this).data('form_value'));
      $.each($(holder).serializeArray(), function( index, item ) {
        formdata.append(item.name,item.value);
      });

      $.ajax({
        type:"POST",
        url:"/options",
        data: formdata,
        dataType: 'JSON',
        processData:false,
        contentType: false,
        success: function(data){
          location.href = data;
        },
        error: function(data){
          var returnedData = JSON.parse(data.responseText);
          $(holder + ' .mesage_form_package').remove();
          $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
          
          $.each(returnedData.messages, function( index, value ) {
            $(holder + " .mesage_form_package").append(value + "<br>");
          }); 
        }
      });
    });

    // CHANGE OPTION DISPLAY_VALUE DROPDOWN
    $(document).on("change", ".option_display_value", function() {
      current_item = $(this);
      $('.value').find('input').val('');
      $('.display_image').find('input').val('');

      if(current_item.val() == 'string' || current_item.val() == 'numeric'){
        $('.value').removeClass('d-none');
        $('.display_image').addClass('d-none');
      }else if(current_item.val() == 'image'){
        $('.value').addClass('d-none');
        $('.display_image').removeClass('d-none');
      }else if(current_item.val() == 'string + image'){
        $('.value').removeClass('d-none');
        $('.display_image').removeClass('d-none');
      }
    });

    $(".chosen-select").chosen();

    // DISABLE SUBMIT BUTTON AFTER FORM SUBMIT
    $(document).on("click", ".submit_order_product", function(e) {
      e.preventDefault();
      $('.submit_order_product').attr("disabled","true");
      $('#submit_value').val($(this).val());
      var isValid = true;

      $.each($("#form_order_product .validation-field"), function(index, item){
        if(!validateElement(item)){
          isValid = false;
        }
      });

      if(!isValid){
        $('.submit_order_product').attr("disabled", false);
      }else{
        $(this).closest('form').submit();
      }
    });

    // GET SECONDARY OPTIONS BASED ON OPTION SELECTED FROM ROOT OPTION LIST FOR ORDER
    $(document).on('change', ".order_option_list", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });

      var current_element = $(this);
      var option_id = current_element.val();
      if($('#order_product_view').length > 0){
        var for_order_product = true;
      }

      var position_nr = current_element.closest('.order_option').data('position_nr');
      $('.order_option').each(function () {
        if(($(this).data('position_nr') > position_nr) && (position_nr != '')){
          $(this).remove();
        }
      });
      current_element.closest('.order_option').data('position_nr',$('.order_option').length);

      if(option_id != ''){
        $.ajax({
          type:"GET", 
          url:'/get_order_options',
          dataType: 'HTML',
          data: {'option_id': option_id, 'for_order_product': for_order_product},
          success: function(data)
          {
            current_element.closest('.order_option').append(data);
          }
        });
      }
    });

    // DROPDOWN WITH IMAGES
    $(document).on("click", ".dropdown-select .dropdown-item", function() {
      var parent = $(this).closest('.dropdown-select');
      var imgselected = parent.next('.img-selected');
      var imgInput = parent.children('button');
      var input = parent.data('input');
      var data = $(this).data('value');
      var img = $(this).children('img').attr('src');
      var text = $(this).text();
      $('#'+input).val(data).trigger('change');
      parent.children('button').find('.selected-item').text(text);
      if(img){
        imgselected.find('.image_selected').removeClass('d-none').attr('src', img);
        imgInput.find('.image_selected').removeClass('d-none').attr('src', img);
        imgInput.find('.selected-item').removeClass('special-two').addClass('special');
      }else{
        imgselected.find('.image_selected').addClass('d-none');        
        imgInput.find('.image_selected').addClass('d-none');
        imgInput.find('.selected-item').removeClass('special').addClass('special-two');      
      }
    });

    // If option has only image and no text, on click on image add option general value.
    $(document).on('click', '.img-selected img.image_selected', function() {
      var selected_item = $(this).parent().prev('.dropdown-select').children('button').find('.selected-item');
      if ( $.trim( selected_item.text() ).length == 0 ) {
        selected_item.text('Select an option');
      }
    });

    // GET PARTIAL DROPDOWN OPTION LIST
    $(document).on('change', "#category_id", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      $('.btn-success').removeClass('disabled');
      var category_id = $(this).val();

      if(category_id != ''){
        $.ajax({
          type:"GET", 
          url:'/get_option_list',
          dataType: 'HTML',
          data: {'category_id': category_id},
          success: function(data)
          {
            $('.option_list_ajax').html(data);
          }
        });
      }else{
        $('.option_list_ajax').html('');
      }
    });

    // CHANGE IS DEFAULT ORDER STATUS
    $(document).on('click', ".checkbox_is_default,.checkbox_root_list", function(e){
      e.preventDefault();
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      var entity_id = $(this).data('entity_id');
      var url = $(this).data('url');

      if($(this).is(":checked")) {
        $.ajax({
          type:"POST", 
          url:'/' + url,
          dataType: 'JSON',
          data: {'entity_id': entity_id},
          success: function(data)
          {
            location.reload();
          }
        });
      }
    });

    // DATEPICKER
    $('#datepicker').datepicker({
        autoclose: true,
        todayHighlight: true,
    });

    //FANCYBOX GALLERY
    /*$(".fancybox-link-custom").fancybox({
    	thumbs   : {
        autoStart : true
      },
      protect: true,
      buttons: [
          "share",
          "fullScreen",
          "thumbs"
      ],
      infobar: false,
      animationEffect: "fade"
    });*/
    // Galleries page masonry
		$('.grid').masonry({
		  itemSelector: '.grid-item',
		  columnWidth: '.grid-sizer',
		  percentPosition: true,
		  gutter: 10
		});

		// Loading Animation
		$('.grid-item').each(function(i) {
		  setTimeout(function() {
		    $('.grid-item').eq(i).addClass('is-visible');
		  }, 200 * i);
		});

		// Fancybox
		$('.fancybox').fancybox({
			thumbs   : {
        autoStart : true
      },
      protect: true,
      buttons: [
          "share",
          "fullScreen",
          "thumbs"
      ],
      infobar: false,
      animationEffect: "fade"
		});

    // DELETE IMAGE GALLERy
    $(document).on("click", ".btn-delete-image", function(e) {
      e.preventDefault();
      var form = $(this).parents('form:first');
      form.submit();
    });

    // SELECT CATEGORIES FOR CATEGORY FIELDS
    $("#select_options,#set_options").change(function() {
      $(this).parent().submit();
    });

    // SUBMIT CURRENT MODAL
    $(".modal_submit").click(function() {
      var rel = $(this).attr('rel');
      $(rel).submit();
    });

    $('#ajax_form_add_user').on('submit',function(e){
      $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
      });
      e.preventDefault();
      $(".modal_submit").addClass('disabled');
      var holder = "#" + $(this).attr('id');
      var ajax_url = $(this).data('ajax_url');

      $.ajax({
        type:"POST",
        url:"/" + ajax_url,
        data:$(this).serialize(),
        dataType: 'JSON',
        success: function(data){
          location.reload();
        },
        error: function(data){
          $(".modal_submit").removeClass('disabled');
          var returnedData = JSON.parse(data.responseText);
          $(holder + ' .mesage_form_package').remove();
          $(holder).prepend("<div class='alert alert-danger mesage_form_package'></div>");
          
          $.each(returnedData.errors, function( index, value ) {
            $(holder + " .mesage_form_package").append(value + "<br>");
          });         
        }
      });
    });

    // SORT CATEGORIES
    $("#sort_category_fields").sortable({
      update: function (event, ui) {
        var sorted = "";
        // get id of the records in order
        $('.category_field_content').each(function () {
            if(sorted == ""){
              sorted = $(this).data('id');
            }else{
              sorted = sorted + "," + $(this).data('id');
            }
        });
        $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });
        $.ajax({
            type: "GET",
            url: '/order_category_fields_ajax',
            dataType: "HTML",
            data: {'category_fields_in_order': sorted},
            success: function(data) {
              console.log(data);
            },
            error: function(data){
            }
        }); 
      }
    });

    // SORT OPTION LISTS
    $(".sort_option_lists").sortable({
      update: function (event, ui) {
        var sorted = "";
        // get id of the records in order
        $('.option_list_content').each(function () {
            if(sorted == ""){
              sorted = $(this).data('id');
            }else{
              sorted = sorted + "," + $(this).data('id');
            }
        });
        $.ajaxSetup({
          headers: {
              'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        });
        $.ajax({
            type: "GET",
            url: '/order_option_lists_ajax',
            dataType: "HTML",
            data: {'option_lists_in_order': sorted},
            success: function(data) {
              console.log(data);
            },
            error: function(data){
            }
        }); 
      }
    });
});
